import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { CONTACT_EMAIL } from "./Navbar";

export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A2621] text-[#FDFBF7] pt-24 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-7">
            <div className="eyebrow text-[#C86A51]">Heritage Homecare Holdings Group LLC</div>

            <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-[#FDFBF7]/80">
              <Link
                to="/nj"
                data-testid="footer-brand-link-nj"
                className="inline-flex items-center gap-1 hover:text-[#C86A51] transition-colors"
              >
                Heritage Homecare
                <span className="text-[#FDFBF7]/50">·</span>
                <span className="text-xs uppercase tracking-[0.2em] text-[#FDFBF7]/60">
                  Hoboken, NJ
                </span>
                <ArrowUpRight size={12} className="opacity-70" />
              </Link>
              <Link
                to="/ny"
                data-testid="footer-brand-link-ny"
                className="inline-flex items-center gap-1 hover:text-[#C86A51] transition-colors"
              >
                Heritage Companion Care
                <span className="text-[#FDFBF7]/50">·</span>
                <span className="text-xs uppercase tracking-[0.2em] text-[#FDFBF7]/60">
                  New York, NY
                </span>
                <ArrowUpRight size={12} className="opacity-70" />
              </Link>
            </div>

            <h3 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-6 leading-[1.05] tracking-tight">
              Honoring your legacy.
              <span className="block italic text-[#E6EAE3]/90">
                Securing the future of your care business.
              </span>
            </h3>

            <a
              href={`mailto:${CONTACT_EMAIL}?subject=Business%20For%20Sale%20Inquiry`}
              data-testid="footer-email-link"
              className="mt-10 inline-flex items-center gap-3 text-lg md:text-xl border-b border-[#FDFBF7]/40 pb-1 hover:text-[#C86A51] hover:border-[#C86A51] transition-colors"
            >
              <Mail size={18} />
              {CONTACT_EMAIL}
              <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.22em] text-[#FDFBF7]/60">
              Navigate
            </div>
            <ul className="mt-5 space-y-3 text-[#FDFBF7]/90">
              <li>
                <a
                  href="#what-we-buy"
                  data-testid="footer-link-what-we-buy"
                  className="hover:text-[#C86A51] transition-colors"
                >
                  What we buy
                </a>
              </li>
              <li>
                <a
                  href="#how-it-works"
                  data-testid="footer-link-process"
                  className="hover:text-[#C86A51] transition-colors"
                >
                  Our process
                </a>
              </li>
              <li>
                <a
                  href="#submit"
                  data-testid="footer-link-submit"
                  className="hover:text-[#C86A51] transition-colors"
                >
                  Submit your business
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  data-testid="footer-link-faq"
                  className="hover:text-[#C86A51] transition-colors"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#FDFBF7]/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#FDFBF7]/60">
          <div>
            © {new Date().getFullYear()} Heritage Homecare Holdings Group LLC. All
            rights reserved.
          </div>
          <div className="font-serif-display italic text-[#FDFBF7]/70">
            Confidential by default. Direct buyer — no brokers.
          </div>
        </div>
      </div>
    </footer>
  );
}
